import React from "react";
import styles from "./business-type.scss";
import Dropdown from "jd-library/Dropdown";
import {getBusinessTypes} from "../../utills"
import { useSelector } from "react-redux";

const BusinessType = (props) => {
  const growerFlag = useSelector(state => state.productSpecification.growerFlag);
  const developerFlag = useSelector(state => state.productSpecification.developerFlag);
  const isReadOnly = useSelector(state => state.session.isReadOnly)
  let optionsList = [];
  let list = getBusinessTypes(growerFlag,developerFlag)
  list.forEach((value, index) => {
    if(!value.hide) {
      optionsList.push({
        label: value.bizType,
        key: value.natCatId,
      });
    }
    })
  const handleChange = (data) => {
    props.handleChange(data.key);
  };
  return (
    <div className={`${styles["business-type"]} ${isReadOnly ? 'business-type-read-only-mode' : ''}`}>
      <Dropdown
        placeholder={props.label}
        label={props.natCatId ? props.label : " "}
        optionList={optionsList}
        onChange={handleChange}
        onFocus={(e) => e.currentTarget.scrollIntoView({ behavior: "smooth" })}
        value={props.natCatId}
        errorMessage={props.error}
        error={props.error}
        placeholderClass={
          styles["business-type"] + " " + styles["placeholder-color"]
        }
      ></Dropdown>
    </div>
  );
};
export default BusinessType;
